// File: src/pages/Dashboard.tsx
import Navbar from '../components/Navbar';

const Dashboard = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      <Navbar />
      <div className="p-6">
        <h1 className="text-3xl font-bold mb-4">Admin Dashboard</h1>
        <p className="text-gray-700">Welcome to the HRMS & SMS SaaS Admin Console.</p>

        <div className="grid grid-cols-2 gap-4 mt-8">
          <div className="bg-white shadow p-4 rounded">
            <h2 className="text-xl font-semibold mb-2">Tenant Management</h2>
            <p className="text-sm text-gray-600">View, add, or manage tenant organizations.</p>
          </div>
          <div className="bg-white shadow p-4 rounded">
            <h2 className="text-xl font-semibold mb-2">User Management</h2>
            <p className="text-sm text-gray-600">Manage users and assign roles per tenant.</p>
          </div>
          <div className="bg-white shadow p-4 rounded">
            <h2 className="text-xl font-semibold mb-2">Module Access Control</h2>
            <p className="text-sm text-gray-600">Control which modules are available per tenant.</p>
          </div>
          <div className="bg-white shadow p-4 rounded">
            <h2 className="text-xl font-semibold mb-2">System Logs</h2>
            <p className="text-sm text-gray-600">Audit trails and activity logs.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;